export default function($compile) {
  'ngInject';

  return {
    priority: 1001,
    terminal: true,
    restrict: 'A',
    scope: {
      progressStatusLabel: '<'
    },
    link: (scope, element, attrs) => {
      const progress = scope.progressStatusLabel;
      const status = !progress
        ? undefined
        : progress.completed
          ? 'Completed'
          : progress.assigned_by
            ? 'Assigned'
            : undefined;

      element.removeAttr('progress-status-label');

      if (!status) {
        return;
      }

      const label = document.createElement('div');
      label.setAttribute('class', `label ${progress.completed ? 'label-success' : 'label-warning'}`);
      const textNode = document.createTextNode(status);
      label.append(textNode);

      /*
       * IE has compatibility issues with append so createTextNode is needed
       */
      if (element.append) element.append(label);
      else if (element.createTextNode) element.createTextNode(String(label));

      $compile(element)(scope);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/progressStatusLabel/index.js